import React from "react";
import { useLang } from "../LangContext";
import { CONTACT } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-cream border-t border-line py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="font-serif text-2xl text-ink leading-tight">
            Notarius <span className="italic text-ink2">Publicus</span>
          </p>
          <p className="mt-3 text-sm text-ink2">{t.footer.tagline}</p>
        </div>
        <div className="text-sm text-ink2 space-y-1">
          <p>{CONTACT.address}</p>
          <p>{CONTACT.phone_display}</p>
          <a
            href={`mailto:${CONTACT.email}`}
            className="underline-offset-4 hover:underline"
          >
            {CONTACT.email}
          </a>
        </div>
        <div className="text-sm text-ink2 md:text-right">
          <p>{t.footer.auth}</p>
          <p className="mt-3">
            © {year} · {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
